import * as React from "react";
import Row from "../../../../layout/Row";
import Col from "../../../../layout/Col";

interface IComponentProps {
	title: string;
	openingHours: any;
}

type Props = IComponentProps;

class OpeningHoursBox extends React.Component<Props> {

	render() {
		const weekDays = [
			'Monday',
			'Tuesday',
			'Wednesday',
			'Thursday',
			'Friday',
			'Saturday',
			'Sunday',
		];
		const {title, openingHours} = this.props;
		return (
			<div className="opening-hours-wrapper">
				<p className="title">{title}</p>
				<div>
					{weekDays.map(day => (
						<Row key={day}>
							<Col xl={3}>
								<p className="weekday-row">{day}</p>
							</Col>
							<Col xl={3}>
								<p className="weekday-row">{openingHours[day.toLowerCase()] === "" || null ? "Closed" :
									`${openingHours[day.toLowerCase()]}`}</p>
							</Col>
						</Row>
					))}
				</div>
			</div>
		);
	}

}

export default OpeningHoursBox;